/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * rebusinession of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambdaへのアクセスのためのドライバーをラップするコード
 * 商品情報をDBから取得する
 */

import Logger from '@/utils/logger';
import ErrorMessage from '@/utils/errorMessages';
import { logoutFunc } from './';
import { IBusiness, IResponse } from '../interfaces';
import * as leanpathDrv from '../leanpathDrv';
// ----ADDITIONAL_IMPORTS----
// ----END-OF-ADDITIONAL_IMPORTS----

/**
 * 商品情報をDBから取得する
 * @param organizationId
 * @param timestamp
 * @returns Promise<IBusiness[]|undefined>
 * @throws {Error} Throws Error object
 */
export const readOrganizationInfoProc = async (organizationId: string, timestamp: number): Promise<IBusiness[] | undefined> => {
  // ----PREPARATION-OF-METHOD----
  // replace here..
  // ----END-OF-PREPARATION----

  try {
    const _resp: IResponse = await leanpathDrv.organizationInfoHandleCall(true, 'ALLNEW', organizationId, timestamp, undefined, undefined);
    if (_resp.success) {
      ErrorMessage.setNoError();
      return _resp.result;
    } else {
      ErrorMessage.set(_resp.message, _resp.code);
      Logger.error(_resp.message);
      return;
    }
  } catch (e) {
    if ((e as Error).toString() === 'Error: refreshToken expired') {
      ErrorMessage.set('refreshトークンの期限が切れたためログアウトします');
      Logger.info('refreshトークンの期限が切れたためログアウトします');
      await logoutFunc();
    }
    ErrorMessage.set((e as Error).toString());
    return;
  }
};
